import React from "react";
import { useApp } from "../../../hooks/useApp.js";

const Toast = () => {
  const { state } = useApp();
  const show = !!state.toast;
  return (
    <div
      className={[
        "fixed right-[-120px] top-[55px] -translate-x-1/2 bg-[var(--ink)] text-[var(--bg)]",
        "px-[18px] py-3 rounded-[10px] text-sm font-semibold pointer-events-none z-[60] transition-all duration-250",
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5",
      ].join(" ")}
    >
      {state.toast}
    </div>
  );
};

export default Toast;
